import Axios from '@/plugins/axios'

// 查询国家列表
export function commonDictCountryList() {
  const config = {
    url: "/seamark/common/data-dict/country-list",
    method: "GET",
  };
  return Axios(config);
}
// 根据国家获取省份
export function commonDictProvinceList(id) {
  const config = {
    url: `/seamark/common/data-dict/sub-province-list/${id}`,
    method: "GET",
  };
  return Axios(config);
}
// 根据省份获取城市
export function commonDictCityList(id) {
  const config = {
    url:`/seamark/common/data-dict/sub-city-list/${id}`,
    method: "GET",
  };
  return Axios(config);
}

// 查询国家和国家区号
export function commonDictCityCode(id) {
  const config = {
    url:'/seamark/common/data-dict/country-codetel-list',
    method: "GET",
  };
  return Axios(config);
}